import LinkToDocusaurus from '../LinkToDocusaurus'
import { monitorPerformance } from '../../docs-routes'

const LinkToMonitorPerformanceDashboardDoc = () =>
  <LinkToDocusaurus path={monitorPerformance}>
    Learn more about Monitor Performance
  </LinkToDocusaurus>

export default LinkToMonitorPerformanceDashboardDoc
